<input type="file" multiple #fileInput (change)="onFileSelected($event)" class="hidden" accept=".pdf,.docx,.txt" />

<div class="space-y-6 backdrop-blur-sm">
    <div class="flex items-center justify-between">
        <div>
            <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Agent Knowledge Base</h2>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Upload documents and manage knowledge sources for
                your agent</p>
        </div>
        <!-- <div>
            <app-button variant="default" [iconNameV2]="'plus'"
                className="flex items-center justify-center gap-2 text-sm font-medium">
                Add Document
            </app-button>
        </div> -->
    </div>

    <div class="grid grid-cols-1">
        <div class="relative">
            <app-icon-v2 name="search" [size]="18" [className]="'absolute left-2 top-3 text-gray-400'"></app-icon-v2>
            <input type="text" placeholder="Search knowledge base..."
                class="w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 px-8 py-2.5 text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 transition-shadow">
        </div>
    </div>

    @if (documents().length == 0 && !loading()) {
        <div class="grid grid-cols-1 rounded-lg border border-gray-300 dark:border-gray-700 bg-gray-100 dark:bg-gray-900 p-6 w-full flex justify-center items-center">
            <div class="flex flex-col items-center justify-between gap-4">
                <div class="flex items-center justify-center p-3 bg-white dark:bg-gray-800 rounded-lg border border-gray-300 dark:border-gray-700">
                    <app-icon-v2 name="files" [size]="18" [className]="'text-gray-700 dark:text-gray-300'"></app-icon-v2>
                </div>
                <div class="flex flex-col gap-1 justify-center items-center">
                    <p class="font-semibold text-sm text-gray-900 dark:text-gray-100">No Documents found</p>
                    <p class="text-sm font-medium text-gray-500 dark:text-gray-400">This agent has no attached documents yet.</p>
                </div>
                <app-button variant="custom" [iconNameV2]="'plus'" (click)="triggerFileInput()"
                    className="flex items-center justify-center gap-2 text-sm font-medium bg-black dark:bg-white text-white dark:text-black border border-gray-300 dark:border-gray-700">
                    Add Document
                </app-button>
            </div>
        </div>
    }

    @if (loading()) {
        <div class="flex items-center justify-center p-8">
            <app-icon-v2 name="loader" [className]="'text-violet-600 animate-spin'" [size]="24"></app-icon-v2>
        </div>
    }

    @if (documents().length > 0) {
        <div class="space-y-3">
            <div class="flex items-center justify-between px-1">
                <h3 class="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                    <app-icon-v2 name="database" [size]="16" class="text-violet-600 dark:text-violet-400"></app-icon-v2>
                    Knowledge Sources ({{ documents().length }})
                </h3>
                <app-button variant="custom" [iconNameV2]="'plus'" (click)="triggerFileInput()"
                    className="flex items-center justify-center gap-1 text-[11px] px-2 py-1 font-medium bg-white dark:bg-gray-900 text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 shadow-sm rounded-md transition-colors hover:bg-gray-50 dark:hover:bg-gray-800">
                    Upload More Documents
                </app-button>
            </div>
            
            <div class="grid grid-cols-1 gap-2 border border-gray-200 dark:border-gray-800 p-2 rounded-xl bg-white/50 dark:bg-gray-950/30">
                @for (doc of documents(); track doc.documentId) {
                <div class="group flex items-center justify-between p-3 rounded-lg border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm hover:border-violet-200 dark:hover:border-line-strong hover:shadow-md transition-all">
                    <div class="flex items-center gap-3 overflow-hidden">
                        <div class="flex items-center justify-center p-2 rounded bg-violet-50 dark:bg-violet-900/20 text-violet-600 dark:text-violet-400 shrink-0">
                            <app-icon-v2 name="file-text" [size]="16"></app-icon-v2>
                        </div>
                        <div class="flex flex-col min-w-0">
                            <span class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate hover:text-violet-600 dark:hover:text-white transition-colors" [title]="extractFilename(doc.documentLink)">
                                {{ extractFilename(doc.documentLink) }}
                            </span>
                            <span class="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">Updated {{ doc.updatedAt | globalDateFormat }}</span>
                        </div>
                    </div>
                    <div class="flex items-center gap-2 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity focus-within:opacity-100" [class.opacity-100]="isDeletingIds().includes(doc.documentId)">
                        <button type="button" class="p-1.5 rounded-md text-gray-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/40 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed" 
                            (click)="deleteDocument(doc.pid, doc.documentId)" [disabled]="isDeletingIds().includes(doc.documentId)">
                            <app-icon-v2 [name]="isDeletingIds().includes(doc.documentId) ? 'loader' : 'trash2'" [size]="15" [className]="isDeletingIds().includes(doc.documentId) ? 'animate-spin' : ''"></app-icon-v2>
                        </button>
                    </div>
                </div>
                }
            </div>
        </div>
    }

    @if (selectedFiles().length > 0) {
    <!-- Native Top-Layer Upload Modal -->
    <dialog #uploadModal class="backdrop:bg-gray-950/70 p-0 m-auto bg-transparent border-0 overflow-visible w-full max-w-4xl outline-none">
        <div class="w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200" (click)="$event.stopPropagation()">
            <div class="px-5 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/80 flex justify-between items-center">
                <h3 class="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                    <app-icon-v2 name="alert-circle" [size]="16" class="text-violet-600 dark:text-violet-400"></app-icon-v2>
                    Ready to upload ({{ selectedFiles().length }})
                </h3>
                <div class="flex items-center gap-5">
                    <button type="button" class="text-sm font-medium text-violet-600 dark:text-violet-400 hover:text-violet-700 dark:hover:text-white transition-colors flex items-center gap-1.5" (click)="triggerFileInput()" [disabled]="isUploading()">
                        <app-icon-v2 name="plus" [size]="14"></app-icon-v2>
                        Add more
                    </button>
                    <button type="button" class="text-sm font-medium text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors" (click)="clearSelectedFiles()" [disabled]="isUploading()">
                        Cancel all
                    </button>
                </div>
            </div>
            
            <ul class="divide-y divide-gray-100 dark:divide-gray-800 max-h-[60vh] overflow-y-auto">
                @for (file of selectedFiles(); track file.name; let i = $index) {
                <li class="flex items-center justify-between px-5 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/40 transition-colors">
                    <div class="flex items-center gap-3 overflow-hidden">
                        <div class="flex items-center justify-center p-2 rounded bg-violet-100 dark:bg-violet-900/30 text-violet-600 dark:text-violet-400 shrink-0">
                            <app-icon-v2 name="file" [size]="16"></app-icon-v2>
                        </div>
                        <div class="flex flex-col min-w-0">
                            <span class="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{ file.name }}</span>
                            <span class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ formatBytes(file.size) }}</span>
                        </div>
                    </div>
                    <button type="button" class="p-2 rounded-md text-gray-400 hover:text-gray-200 hover:bg-gray-800 transition-colors" (click)="removeSelectedFile(i)" [disabled]="isUploading()">
                        <app-icon-v2 name="x" [size]="16"></app-icon-v2>
                    </button>
                </li>
                }
            </ul>

            <div class="px-5 py-4 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 flex justify-end">
                <app-button variant="custom" [iconNameV2]="isUploading() ? 'loader' : 'upload'" (click)="uploadFiles()" [disabled]="isUploading()"
                    className="flex items-center justify-center gap-2 text-sm font-medium min-w-[140px] bg-violet-600 hover:bg-violet-700 text-white rounded-lg px-4 py-2 transition-colors">
                    {{ isUploading() ? 'Uploading...' : 'Upload Files' }}
                </app-button>
            </div>
        </div>
    </dialog>
    }
</div>